import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {SquareButton} from "@/scenes.ui/square-button";
import {Keys} from "@/constants/key";
import CU from "@/utils/c-u";
import SpriteUtils from "@/utils/sprite-utils";
import {StringUtils} from "@/utils/string-utils";
import {BigStandardPanel} from "@/scenes.ui/big-standard-panel";
import {FeedbackPanel} from "@/scenes.ui/feedback-panel";
import PlayerStore from "@/store/player";
import {IntegrationUtils} from "@/utils/integration-utils";

export class EarnGemsDetailsPanel extends BigStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, refCode: string) {
        super(scene, canvas, Tr('gn.gems'));

        this.setDepth(3000);
        let self = this;

        SpriteUtils.scale(this, 1.1 / CU.S, 1.1 / CU.S);
        this.xButton.x += -5;
        this.xButton.y += 7;

        let title = TextUtils.addTextByFamily(scene,  Tr('send.ref.link.to.friend'),
            0, -250, '#ffd465', 14, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let refLink = IntegrationUtils.getRefLink(PlayerStore.getPlayer(), refCode);
        let refLinkText = TextUtils.addTextByFamily(scene, refLink!,
            0, -215, '#716f6a', 13, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let shareButtonVisible = !CU.isDesktop() && !IntegrationUtils.isExternalUser();
        let customShareButtonVisible = !!this.getCustomShareImage();
       // let shareButtonVisible = true;
       //  let customShareButtonVisible = true;

        let copyButton = new SquareButton(scene, 0 +  (shareButtonVisible || customShareButtonVisible ? -100 : 0), -150 , 0, Keys.UI_ART_PALE_BUTTON,
            undefined, Keys.UI_COPY, Tr('copy.msg'), false, 80, 80);

        copyButton.setCallback(() => {
            IntegrationUtils.copyToClipboard(refLink!);
            new FeedbackPanel(scene, Tr('copied'), undefined, true).show();
        })
        copyButton.setScale(0.60);

        let shareButton = new SquareButton(scene, 100, -150, 0, Keys.UI_ART_PALE_BUTTON,
            undefined, Keys.UI_SHARE, Tr('share2'), false, 80, 80);

        shareButton.setCallback(() => {
            const data = {
                title: Tr('social.invite.text'),
                text: Tr('social.invite.bonus'),
                url: refLink!,
            };
            navigator.share(data);
        })
        shareButton.setScale(0.60);
        shareButton.setVisible(shareButtonVisible);

        let customShareButton = new SquareButton(scene, 0 +  (shareButtonVisible? 0 : 100), -150, 0, Keys.UI_ART_PALE_BUTTON,
            undefined, this.getCustomShareImage(), Tr('share2'), false, 80, 80);

        customShareButton.setCallback(() => {
            self.customShareCallback(refCode);
        })
        customShareButton.setScale(0.60);
        customShareButton.setVisible(customShareButtonVisible);

        let dx = -190;
        let dy = -105;

        PlayerStore.getManual('referral_system_desc').then(desc => {
            this.addTextWithDots(scene, desc, dx, dy);
        });

        PlayerStore.getManual('referral_system_desc2').then(desc => {
            this.addTextWithDots(scene, desc, dx, dy + 250, 0.9, '#807f7f', 0.7);
        });

        // let clickSound = SoundUtils.addSound(scene, Keys.SOUND_BUTTON_CLICK);

        // const rulesButton = SpriteUtils.addImage(this.scene, -195, 300, Keys.ATLAS_UI_2, Keys.UI2_FORUM, 0.8, 0.8).setOrigin(0.5, 0.5);
        // rulesButton.setInteractive().on('pointerup', ()=>{
        //     PlayerStore.getManual('referral_system_rules').then(man => {
        //         let ip: NewsPanel = new NewsPanel(scene, canvas, Tr('ft.rules').toUpperCase(), man, () => {
        //             ip.close();
        //         }, false, true);
        //         ip.openAnimated();
        //     });
        // })
        // let rulesText = TextUtils.addTextByFamily(scene,  Tr('ft.rules').toLowerCase(),
        //     -195, 328, '#ffffff', 11, 'normal', 450, Fonts.MYRIADPRO_REGULAR);

        this.add([title, refLinkText, copyButton, shareButton, customShareButton])//, rulesButton, rulesText]);
    }

    private getCustomShareImage(){
        if(IntegrationUtils.isOkUser()){
            return Keys.UI_SHARE_OK;
        } else if(IntegrationUtils.isVkUser()){
            return Keys.UI_SHARE_VK;
        }
        else if (IntegrationUtils.isCrazyUser() || IntegrationUtils.isKongUser()){
            return Keys.UI_SHARE_FB;
        }
        return "";
    }

    private customShareCallback(refCode:string) {
        if(IntegrationUtils.isOkUser()){
            IntegrationUtils.showOkInviteDialog(Tr('social.invite.text'), refCode);
            return;
        } else if(IntegrationUtils.isVkUser()){
            IntegrationUtils.showVkInviteDialog(Tr('social.invite.text'), refCode);
            return;
        } else if (IntegrationUtils.isCrazyUser() || IntegrationUtils.isKongUser()){
            IntegrationUtils.showFbShareWindow(PlayerStore.getPlayer(), refCode);
            return;
        }
    }

    private addTextWithDots(scene: Scene, description:string, dx:number, dy:number, scale?:number, color?:string, dotAlpha?:number):void{
        let descriptions:Phaser.GameObjects.Text[] = [];
        let dots:Phaser.GameObjects.Image[] = [];
        this.prepareDescription(description).forEach((desc, index) => {
            let addGoldDot = false;
            if(desc.startsWith("-")) {
                addGoldDot = true;
                desc = desc.substring(1);
            }
            let height = descriptions.reduce((acc, d) => acc + d.height, 0);
            let line = TextUtils.addTextAdvanced(scene, desc, dx + (addGoldDot? 10 : -20) * (scale || 1), dy + (height + index * 10) * (scale || 1),
                addGoldDot? (color || '#eed28d') : (color || '#86e87e'), 13 / CU.S, 'normal', (addGoldDot ? 390 : 430) / (scale || 1) / CU.S, 'left', 2, Fonts.MYRIADPRO_REGULAR);
            line.setOrigin(0, 0);
            line.setScale((scale || 1) * CU.S)

            if(addGoldDot){
                let goldDot = SpriteUtils.addSprite(this.scene, dx -10 * (scale || 1), dy + height + (index * 10 + 12) * (scale || 1),
                    Keys.UI_GOLD_DOT, undefined, 1, 1);
                dots.push(goldDot);
                goldDot.setScale((scale || 1) * CU.S);
                goldDot.setAlpha(dotAlpha || 1);
            }
            descriptions.push(line);
        })
        this.add([...descriptions, ...dots]);
    }

    private prepareDescription(descText: string): string[] {
        let versions = descText.split('[long]');
        descText = versions[0].trim();

        descText = descText.replace('[g]', '[color=#e0a141]');
        descText = descText.replace('[r]', '[color=#6e3c3c]');
        descText = descText.replace('[v]', '[color=#71d565]');
        descText = descText.replace('[/g]', '[/color]');
        descText = descText.replace('[/r]', '[/color]');
        descText = descText.replace('[/v]', '[/color]');

        let dot = '•';
        descText = descText.trim()
        descText = descText.toLowerCase()
        let parts = descText.split('\n');
        descText = parts.map(part => StringUtils.capitalizeFirstLetter(part.trim())).join("\n" + dot)
        descText =  dot + " " + descText;
        // return descText;
        return descText.split('•');
    }


}
